import { useCallback } from 'react';
import { Flex, Typography, IconSearch } from '@banhala/ui-kit';
import type { SearchBarProps } from './types';
import { bridge, isNil, renderHTMLToText } from '../../../../utils';

export const SearchBar = ({ entity, body }: SearchBarProps) => {
  // body에서 데이터를 가져오거나 entity에서 가져옴
  const item = body?.item ?? entity?.[0]?.item;

  const handlePress = useCallback(() => {
    if (item?.deeplink) {
      bridge.openDeeplink(item.deeplink);
    }
  }, [item?.deeplink]);

  if (isNil(item)) {
    return null;
  }

  const { placeholder, deeplink, border_color } = item;

  return (
    <Flex.Column padding={{ horizontal: 12 }}>
      <Flex.Row
        height={48}
        borderWidth={2}
        borderColorValue={border_color}
        borderRadius={4}
        alignItems="center"
        padding={{ horizontal: 10 }}
        onPress={handlePress}
        disabled={!deeplink}
      >
        <Flex padding={{ right: 4 }}>
          <IconSearch width={20} height={20} color="content_secondary" />
        </Flex>
        <Typography type="subtitle3" color="content_secondary">
          {renderHTMLToText(placeholder)}
        </Typography>
      </Flex.Row>
    </Flex.Column>
  );
};
